import { Component, ViewEncapsulation, Input, OnInit, OnDestroy } from '@angular/core';
import { OfflineStatusService, LoggedInUserService } from '@formbird/services';
import { OfflineStatus } from '@formbird/types';
import { Subscription } from 'rxjs';

@Component({
    selector: 'ft-offline-status',
    templateUrl: 'offline-status.component.html',
    styleUrls: ['./offline-status.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class OfflineStatusComponent implements OnInit, OnDestroy {

    mode = 'determinate';

    private sub: Subscription;

    
    @Input() offlineStatus: OfflineStatus;
    appValue: any;
    dataValue: any;
    mapValue: any;
    isMenuOpened: false;
    isErrorSyncMenuOpened: false;
    fileValue: any;
    constructor(
        private offlineStatusService: OfflineStatusService,
        private loggedInUserService: LoggedInUserService,
    ) {
        this.sub = this.offlineStatusService.offlineStatus$.subscribe((offlineStatusData) => {
            this.offlineStatus = offlineStatusData;

            this.appValue = (this.offlineStatus.currentStaticResourceCount / this.offlineStatus.totalStaticResourceCount ) * 100;
            this.dataValue = (this.offlineStatus.currentCacheCount / this.offlineStatus.maxCacheCount ) * 100;
            this.mapValue = (this.offlineStatus.tileServerCacheCount / this.offlineStatus.tileServerMaxCacheCount ) * 100;
        });
        

        
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    clearErrorCachingAttachedFiles(){
      this.offlineStatusService.offlineStatus.errorCacheAttachedFile = [];
      this.loggedInUserService.setUserConfigItem('ErrorCachingAttachedFiles', this.offlineStatusService.offlineStatus.errorCacheAttachedFile);
    }

    errorMenuClick(isOpen, flag? ){
      if (flag === 'syncDoc'){
        this.isErrorSyncMenuOpened = isOpen;
      } else {
        this.isMenuOpened = isOpen;
      }
    }

    closeProgress() {
      const divSWUpdateIndicator = document.getElementById('swUpdateProgressIndicator');
      if (divSWUpdateIndicator) {
        divSWUpdateIndicator.classList.remove('show');
      }
    }

    clearErrorOfflineChangesSyncDocs(){
      this.offlineStatusService.offlineStatus.errorOfflineChangesSyncDocs = [];
      this.loggedInUserService.setUserConfigItem('ErrorOfflineChangesSyncDocs', this.offlineStatusService.offlineStatus.errorOfflineChangesSyncDocs);
    }
    //disable if the menu has no content to prevent dropdown 
    isMenuEnabled(): boolean {
      return (this.offlineStatus?.cachingApp && this.offlineStatus?.currentStaticResourceCount > 0) ||
             (typeof this.offlineStatus?.cacheLoading === 'number' && this.offlineStatus.cacheLoading > 0) ||
             (this.offlineStatus?.maxCacheCount > 0) ||
             (this.offlineStatus?.pendingDocumentCount > 0) ||
             (this.offlineStatus?.tileServerCacheCount > 0) ||
             (this.offlineStatus?.errorCacheAttachedFile.length > 0);
  }
}